<template>
  <div class="video__overlay" :class="SelectorClass">
    <div class="video__overlay--inner">
      <div class="video__overlay--close" v-on:click="closeOverlay($event)">
        <img src="@/assets/icons/white/close.svg">
      </div>
      <div class="video__overlay--wrapper">
        <video src="@/assets/videos/s01_intro.mp4" controls v-if="lang != 'ES'">

        </video>
        <video src="@/assets/videos/s01_intro_es.mp4" controls v-if="lang == 'ES'">

        </video>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
      filename: ''
    }
  },
  name: "VideoOverlay",
  props: {
    Source: String,
    SelectorClass: String,
    lang: String
  },
  methods: {
    closeOverlay(event) {
      let overlay = event.currentTarget.parentElement.parentElement;
      overlay.classList.remove("open");

      let video = document.querySelector(".video__overlay video");
      video.pause();

    },
    playVideo(filename) {
      this.filename = '/assets/videos/' + filename;
      let video = document.querySelector(".video__overlay video");
      // video.src = this.filename;
      video.play();

    }
  },

}
</script>

<style lang="scss" scoped>
.video__overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999;
  background-color: rgba(0, 0, 0, 1);
  display: flex;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: 0.25s ease-out;

  &.open {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }

  .video__overlay--wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 1);
  }

  .video__overlay--inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
  }

  .video__overlay--close {
    position: absolute;
    z-index: 22222;
    cursor: pointer;

    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    background-color: #280071;
    border-radius: 20px;

    img {
      width: 14px;
      height: auto;
      margin: 13px 0 0 13px;
    }

  }

  video {
    width: 100%;
    height: auto;
    max-height: 100vh;
  }

}
</style>